import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizedGuardService } from '@rtls/core/guards';
import { provideGuardForPermission } from '@rtls/shared/user/user-permissions.guard';
import { UserPermissions } from '@rtls/shared/user/user-permissions';
import { RedirectComponent } from '@rtls/shared/components/redirect/redirect.component';
import { provideGuardForPermissionWithAccessControl } from '@rtls/shared/user/user-permissions-access-control.guard';
import { RailwatchComponent } from './railwatch/railwatch.component';

const routes: Routes = [
	{
		path: 'dashboard',
		loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
		canActivate: [AuthorizedGuardService, provideGuardForPermission([UserPermissions.readStatistics])],
	},
	{
		path: 'settings',
		loadChildren: () => import('settings').then((m) => m.SettingsModule),
		canActivate: [
			AuthorizedGuardService,
			provideGuardForPermissionWithAccessControl([], [UserPermissions.readSettings, UserPermissions.readJourney]),
		],
	},
	{
		path: 'transports',
		loadChildren: () => import('./transports-home/transports-home.module').then((m) => m.TransportsHomeModule),
		canActivate: [AuthorizedGuardService, provideGuardForPermission([UserPermissions.readTransports])],
	},
	{
		path: 'delivery-tracking',
		loadChildren: () =>
			import('./transport-planning/transport-planning.module').then((m) => m.TransportPlanningModule),
		canActivate: [AuthorizedGuardService],
	},
	{
		path: 'map',
		loadChildren: () => import('./map/map.module').then((m) => m.MapModule),
		canActivate: [
			AuthorizedGuardService,
			provideGuardForPermissionWithAccessControl(
				[UserPermissions.readThings, UserPermissions.readLocations],
				[UserPermissions.readMap],
			),
		],
	},
	{
		path: 'yard',
		loadChildren: () => import('./yard/yard.module').then((m) => m.YardModule),
		canActivate: [AuthorizedGuardService],
	},
	{
		path: 'devs',
		loadChildren: () => import('./devs/devs.module').then((m) => m.DevsModule),
		canActivate: [AuthorizedGuardService],
	},
	{
		path: 'statistics',
		loadChildren: () => import('./statistics/statistics.module').then((m) => m.StatisticsModule),
		canActivate: [AuthorizedGuardService],
	},
	{
		path: 'error',
		loadChildren: () =>
			import('./exception-page/exception-page-routing.module').then((m) => m.ExceptionPageRoutingModule),
	},
	{
		path: 'execution',
		loadChildren: () => import('execution').then((m) => m.ExecutionModule),
		canActivate: [AuthorizedGuardService],
	},
	{
		path: 'reporting',
		loadChildren: () => import('reporting').then((m) => m.ReportingModule),
		canActivate: [AuthorizedGuardService],
	},
	{
		path: 'railwatch',
		component: RailwatchComponent,
		canActivate: [AuthorizedGuardService],
	},
	{ path: '', pathMatch: 'full', component: RedirectComponent, canActivate: [AuthorizedGuardService] },
	{ path: '**', pathMatch: 'full', redirectTo: 'error' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {})],
	exports: [RouterModule],
})
export class AppRoutingModule {}
